<template>
  <span
    id="wish-list-widget"
    class="wp_wishListSpan"
  >
    <!-- <a v-show="(!isInWishlist(product.product_id) && !wishListIcon)"
          class="btn-wishlist wishlist-btn"
         href=""
         @click.stop.prevent="addToWish"
         :id="'add-to-wishlist-link'+product.product_id"
      >
      <div class="icon icon--ei-heart icon--s">
        <img class="icon_cnt"
             src="@/assets/svg/ei-heart.svg"
             alt=""
             srcset=""
             :id="'add-to-wishlist-img'+product.product_id"
        >
      </div>
        <span :id="'add-to-wishlist'+product.product_id">
          Add to Wishlist
        </span>
      </a> -->
    <!-- v-show="(!isInWishlist(product.product_id) && wishListIcon)" -->
    <span
      class="btn-wishlist-span"
      v-if="!isInWishlist(product.product_id)"
    >
      <button
        title="Add to wishlist"
        class="btn-wishlist"
        @click.stop="addToWish(product)"
        :id="'add-to-wishlist-btn'+product.product_id"
								:data-test="'wishListAddToBtn'+position"
      >
        <!--<svg class="i-icon icon-heart"-->
        <!--:id="'add-to-wishlist-icon'+product.product_id"-->
        <!--&gt;-->
        <svg
          :id="'icon-heart'+product.product_id"
          viewBox="0 0 32 32"
          width="100%"
          height="100%"
          class="icon-heart3"
										:data-test="'wishListSvg'+position"
        >
          <path d="M23.6 2c-3.363 0-6.258 2.736-7.599
              5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637
              0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001
              21.232 6.13-9.268 15.999-12.1 15.999-21.232
              0-4.637-3.763-8.401-8.4-8.401z">
          </path>
        </svg>
        <!--</svg>-->
        <!--<span class="name"></span>-->
      </button>
    </span>

    <span
      class="btn-wishlist-span"
      v-else
    >
      <button
        title="Remove from wishlist"
        class="btn-wishlist"
        @click.stop="deleteFromWish(product.product_id)"
        :id="'add-to-wishlist-btn'+product.product_id"
								:data-test="'wishListRemoveBtn'+position"
      >
        <!--<svg class="i-icon icon-heart"-->
        <!--:id="'add-to-wishlist-icon'+product.product_id"-->
        <!--&gt;-->
        <svg
          :id="'icon-heart'+product.product_id"
          viewBox="0 0 32 32"
          width="100%"
          height="100%"
          class="icon-heart4"
										:data-test="'wishListRemoveSvg'+position"
        >
          <path d="M23.6 2c-3.363 0-6.258 2.736-7.599
            5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637
            0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906
            16.001 21.232 6.13-9.268 15.999-12.1
            15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z">
          </path>
        </svg>
        <!--</svg>-->
        <!--<span class="name"></span>-->
      </button>
    </span>

  </span>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { customerApi } from '@/services/ApiServices/customerApi'

export default {
	name: 'WishlistAction',
	props: {
		product: Object,
		wishListIcon: {
			type: Boolean,
			default: false
		},
		position: {
			type: Number,
			default: 0
		}
	},
	data () {
		return {}
	},
	computed: {
		...mapGetters('user', ['isAuthenticated']),
		// ...mapGetters('recentview', ['getRecentData']),
		...mapGetters('wishlist', ['isInWishlist', 'getWishlistProducts'])
	},
	methods: {
		...mapActions('wishlist', ['addToWishlist', 'deleteFromWishlist']),
		// ...mapActions('recentview', ['setRecentData']),
		addToWish () {
			if (this.isAuthenticated) {
				this.$toasted.show('Added to Wishlist ')
				this.addToWishlist(this.product.product_id)
				this.updateWishList()
			} else {
				this.$router.push({
					path: '/login',
					query: {
						next_to: 'wishList',
						product_id: this.product.product_id
					}
				})
			}
		},
		deleteFromWish (product) {
			if (this.isAuthenticated) {
				this.deleteFromWishlist(product)
				this.updateWishList()
				this.$toasted.show('Removed from wishlist')
			} else {
				$('#myModal-login')
					.modal('show')
			}
		},
		updateWishList () {
			customerApi.insertWishList()
		}
	}
}
</script>
